// Routing reads this bounded observation only. Branding fields may contain defaults.
export const emptyShopRouteOrigin = () => ({ version: 1, state: 'unavailable', address: null,
  latitude: null, longitude: null, revision: null });

export function projectShopRouteOrigin(value) {
  if (!value || typeof value !== 'object' || Array.isArray(value)
    || value.version !== 1 || !['ready', 'unconfirmed', 'unavailable'].includes(value.state)
    || !['address', 'latitude', 'longitude', 'revision'].every(key => Object.hasOwn(value, key))) {
    throw new Error('Invalid shop route origin');
  }
  const { state, address, latitude, longitude, revision } = value;
  const text = field => field === null || (typeof field === 'string' && !!field.trim());
  const pair = typeof latitude === 'number' && Number.isFinite(latitude) && Math.abs(latitude) <= 90
    && typeof longitude === 'number' && Number.isFinite(longitude) && Math.abs(longitude) <= 180;
  if (!text(address) || !text(revision)
    || (state === 'ready' ? !address || !revision || !pair : latitude !== null || longitude !== null)) {
    throw new Error('Invalid shop route origin');
  }
  return { version: 1, state, address: address?.trim() || null, latitude, longitude, revision };
}

export function selectShopRouteOrigin(origin, { online = true } = {}) {
  let observation;
  try { observation = projectShopRouteOrigin(origin); } catch { observation = emptyShopRouteOrigin(); }
  const point = observation.state === 'ready'
    ? { lat: observation.latitude, lng: observation.longitude } : null;
  const address = observation.address?.replace(/\s+/g, ' ').trim() || null;
  const input = point || (online ? address : null);
  return {
    state: input ? 'ready' : origin?.acquisition === 'loading' ? 'loading' : 'unavailable',
    // Revision prevents stale writes; equal chosen inputs still describe the same route.
    identity: JSON.stringify([origin?.source || null, point ? ['point', point.lat, point.lng]
      : input ? ['address', address] : ['unavailable']]),
    point, address, input, stale: !!input && origin?.acquisition === 'error', error: origin?.error || '',
  };
}
